import { createLucideIcon } from "lucide-react";

export const Sorting19 = createLucideIcon(
    "Sorting19",
    [
        [
            "path",
            {
                d: "M16.5 19.9991C15.7998 19.9991 14.4915 18.0048 14 17.4991",
                key: "1y8t67",
            },
        ],
        [
            "path",
            {
                d: "M16.5 19.9991C17.2002 19.9991 18.5085 18.0048 19 17.4991",
                key: "5h0by9",
            },
        ],
        [
            "path",
            {
                d: "M16.5 19.9991V3.9992",
                key: "16g5ph",
            },
        ],
        [
            "path",
            {
                d: "M7 9.9994H5.5",
                key: "1o29a7",
            },
        ],
        [
            "path",
            {
                d: "M7 9.9994H8.5",
                key: "5725w1",
            },
        ],
        [
            "path",
            {
                d: "M7 9.9994V3.9481C7 3.3736 7 3.0863 6.7696 3.0149C6.2631 2.8577 5.5 3.999 5.5 3.999",
                key: "ss64a9",
            },
        ],
        [
            "path",
            {
                d: "M9 17.4991V15.7491C9 14.9242 9 14.5117 8.7071 14.2554C8.4142 13.9991 7.9428 13.9991 7 13.9991C6.0572 13.9991 5.5858 13.9991 5.2929 14.2554C5 14.5117 5 14.9242 5 15.7491C5 16.5741 5 16.9866 5.2929 17.2429C5.5858 17.4991 6.0572 17.4991 7 17.4991H9Z",
                key: "y8q30d",
            },
        ],
        [
            "path",
            {
                d: "M9 17.4991V18.3741C9 19.6116 9 20.2303 8.5607 20.6147C8.1213 20.9991 7.4142 20.9991 6 20.9991H5",
                key: "12bqn5",
            },
        ],
    ],
);
